import { render, staticRenderFns } from "./MaterialBarChartCard.vue?vue&type=template&id=1b4dcfad"
import script from "./MaterialBarChartCard.vue?vue&type=script&lang=js"
export * from "./MaterialBarChartCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialBarChartCard.vue?vue&type=style&index=0&id=1b4dcfad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports